var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "Availability-wrapper has-background-white mt-8 mb-8 pb-6 pr-6 pl-6 pt-6",
    },
    [
      _c("p", { staticClass: "hb-fonts-heading-5-bold mb-3" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.availabilityTitle || "Arzttermin ohne lange Wartezeit") +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "hb-fonts-body-regular has-text-weight-light is-italic",
        },
        [
          _vm._v(
            "\n    Wir haben für Sie in den nächsten 24 Stunden die folgenden Arzttermine frei:\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("AvailabilityTable", {
            attrs: {
              "availability-per-slot": _vm.availabilityPerSlot,
              "first-day-date": _vm.firstDayDateString,
              "second-day-date": _vm.secondDayDateString,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "hb-fonts-body-regular has-text-weight-light is-italic",
        },
        [
          _vm._v(
            "\n    Sie können Ihren Termin ganz einfach direkt über die App buchen. Jetzt herunterladen und heute noch Termin vereinbaren.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c("AppButtons", {
        staticClass: "mt-5",
        attrs: {
          "android-download-image": _vm.androidDownloadImage,
          "play-store-url": _vm.playStoreUrl,
          "ios-download-image": _vm.iosDownloadImage,
          "app-store-url": _vm.appStoreUrl,
          "tracking-screen": "App Landing CTA",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }